import type { LucideIcon } from 'lucide-react';
import {
  ArrowRight,
  Award,
  BarChart3,
  BookOpen,
  Calendar,
  Check,
  CheckCircle2,
  Clock,
  Gift,
  Globe,
  GraduationCap,
  Heart,
  Lightbulb,
  Lock,
  Mail,
  MessageCircle,
  Mic,
  Package,
  Palette,
  PenTool,
  PlayCircle,
  Rocket,
  Shield,
  Sparkles,
  Star,
  Target,
  ThumbsUp,
  TrendingUp,
  Trophy,
  Users,
  Video,
  Zap,
} from 'lucide-react';

export type LoSiteIconId =
  | 'star'
  | 'check'
  | 'check-circle'
  | 'zap'
  | 'target'
  | 'award'
  | 'trophy'
  | 'rocket'
  | 'heart'
  | 'thumbs-up'
  | 'lightbulb'
  | 'book-open'
  | 'graduation-cap'
  | 'users'
  | 'mail'
  | 'message-circle'
  | 'video'
  | 'calendar'
  | 'clock'
  | 'shield'
  | 'lock'
  | 'globe'
  | 'sparkles'
  | 'trending-up'
  | 'bar-chart'
  | 'gift'
  | 'package'
  | 'pen-tool'
  | 'palette'
  | 'mic'
  | 'play-circle'
  | 'arrow-right';

export interface LoSiteIconOption {
  id: LoSiteIconId;
  label: string;
  Icon: LucideIcon;
}

export const LO_SITE_ICON_OPTIONS: LoSiteIconOption[] = [
  { id: 'star', label: 'Étoile', Icon: Star },
  { id: 'check', label: 'Validation', Icon: Check },
  { id: 'check-circle', label: 'Coche', Icon: CheckCircle2 },
  { id: 'zap', label: 'Éclair', Icon: Zap },
  { id: 'target', label: 'Cible', Icon: Target },
  { id: 'award', label: 'Médaille', Icon: Award },
  { id: 'trophy', label: 'Trophée', Icon: Trophy },
  { id: 'rocket', label: 'Fusée', Icon: Rocket },
  { id: 'heart', label: 'Cœur', Icon: Heart },
  { id: 'thumbs-up', label: 'Pouce', Icon: ThumbsUp },
  { id: 'lightbulb', label: 'Idée', Icon: Lightbulb },
  { id: 'book-open', label: 'Livre', Icon: BookOpen },
  { id: 'graduation-cap', label: 'Formation', Icon: GraduationCap },
  { id: 'users', label: 'Communauté', Icon: Users },
  { id: 'mail', label: 'E-mail', Icon: Mail },
  { id: 'message-circle', label: 'Message', Icon: MessageCircle },
  { id: 'video', label: 'Vidéo', Icon: Video },
  { id: 'calendar', label: 'Calendrier', Icon: Calendar },
  { id: 'clock', label: 'Horloge', Icon: Clock },
  { id: 'shield', label: 'Sécurité', Icon: Shield },
  { id: 'lock', label: 'Confidentialité', Icon: Lock },
  { id: 'globe', label: 'Monde', Icon: Globe },
  { id: 'sparkles', label: 'Magie', Icon: Sparkles },
  { id: 'trending-up', label: 'Croissance', Icon: TrendingUp },
  { id: 'bar-chart', label: 'Statistiques', Icon: BarChart3 },
  { id: 'gift', label: 'Cadeau', Icon: Gift },
  { id: 'package', label: 'Pack', Icon: Package },
  { id: 'pen-tool', label: 'Création', Icon: PenTool },
  { id: 'palette', label: 'Design', Icon: Palette },
  { id: 'mic', label: 'Micro', Icon: Mic },
  { id: 'play-circle', label: 'Lecture', Icon: PlayCircle },
  { id: 'arrow-right', label: 'Flèche', Icon: ArrowRight },
];

const ICON_MAP = Object.fromEntries(
  LO_SITE_ICON_OPTIONS.map((opt) => [opt.id, opt.Icon]),
) as Record<LoSiteIconId, LucideIcon>;

export function isLoSiteIconId(value: string | undefined): value is LoSiteIconId {
  return !!value && value in ICON_MAP;
}

export function getLoSiteIconComponent(iconId: string | undefined): LucideIcon | null {
  if (!iconId || !isLoSiteIconId(iconId)) return null;
  return ICON_MAP[iconId];
}

export function getLoSiteIconLabel(iconId: string | undefined): string {
  if (!iconId) return '';
  return LO_SITE_ICON_OPTIONS.find((opt) => opt.id === iconId)?.label ?? iconId;
}
